<template>
  <div id="app">
    <flexbox></flexbox>
  </div>
</template>

<script>
import components from './components.js'
export default {
  name: 'app',
  components
}
</script>

<style lang="scss">
@import "global";
</style>



// WEBPACK FOOTER //
// App.vue?a167e95e